import {
  FETCH_LINEAGES_REQUEST,
  FETCH_LINEAGES_SUCCESS,
  FETCH_LINEAGES_FAILURE,
  DELETE_LINEAGE_REQUEST,
  DELETE_LINEAGE_SUCCESS,
  DELETE_LINEAGE_FAILURE,
  LOAD_INSTANCES_REQUEST,
  LOAD_INSTANCES_SUCCESS,
  LOAD_INSTANCES_FAILURE,
  LOAD_OBJECTS_REQUEST,
  LOAD_OBJECTS_SUCCESS,
  LOAD_OBJECTS_FAILURE,
  DISCOVER_VIEW_LINEAGE_REQUEST,
  DISCOVER_VIEW_LINEAGE_SUCCESS,
  DISCOVER_VIEW_LINEAGE_FAILURE,
} from './data-lineage.actions';

const initialState = {
  lineages: [],
  loading: false,
  error: null,
  instances: [],
  instancesLoading: false,
  instancesError: null,
  objects: [],
  objectsLoading: false,
  objectsError: null,
  viewLineage: null,
  viewLineageLoading: false,
  viewLineageError: null,
};

export default function dataLineage(state = initialState, action) {
  switch (action.type) {
    case FETCH_LINEAGES_REQUEST:
      return {...state, loading: true, error: null};
    case FETCH_LINEAGES_SUCCESS: {
      const lineagesData = Array.isArray(action.payload) ?
        action.payload :
        (action.payload && (action.payload.response || action.payload.data)) || [];
      return {...state, loading: false, lineages: lineagesData};
    }
    case FETCH_LINEAGES_FAILURE:
      return {...state, loading: false, error: action.payload};

    case DELETE_LINEAGE_REQUEST:
      return {...state, loading: true};
    case DELETE_LINEAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        lineages: state.lineages.filter((l) => (l.id || l.diagram_id) !== action.payload),
      };
    case DELETE_LINEAGE_FAILURE:
      return {...state, loading: false, error: action.payload};

    case LOAD_INSTANCES_REQUEST:
      return {...state, instancesLoading: true, instancesError: null};
    case LOAD_INSTANCES_SUCCESS:
      const instances = (action.payload && action.payload.response) || action.payload || [];
      return {...state, instancesLoading: false, instances, instancesError: null};
    case LOAD_INSTANCES_FAILURE:
      return {...state, instancesLoading: false, instancesError: action.payload};

    case LOAD_OBJECTS_REQUEST:
      return {...state, objectsLoading: true, objectsError: null};
    case LOAD_OBJECTS_SUCCESS: {
      const objs = action.payload && action.payload.response && action.payload.response.objects ?
        action.payload.response.objects :
        action.payload || [];
      return {...state, objectsLoading: false, objects: objs, objectsError: null};
    }
    case LOAD_OBJECTS_FAILURE:
      return {...state, objectsLoading: false, objectsError: action.payload};

    case DISCOVER_VIEW_LINEAGE_REQUEST:
      return {...state, viewLineageLoading: true, viewLineageError: null};
    case DISCOVER_VIEW_LINEAGE_SUCCESS:
      return {...state, viewLineageLoading: false, viewLineage: action.payload, viewLineageError: null};
    case DISCOVER_VIEW_LINEAGE_FAILURE:
      return {...state, viewLineageLoading: false, viewLineageError: action.payload};

    default:
      return state;
  }
}
